import { CorbadoApp } from '@corbado/web-core';
import { useCallback, useEffect, useState } from 'react';
import React from 'react';
import { useTelemetry } from '../hooks/useTelemetry';
import { CorbadoSessionContext } from './CorbadoSessionContext';
export const CorbadoSessionProvider = ({ children, corbadoAppInstance, corbadoAppParams, }) => {
    const [corbadoApp] = useState(() => corbadoAppInstance !== null && corbadoAppInstance !== void 0 ? corbadoAppInstance : new CorbadoApp(corbadoAppParams));
    const [globalError, setGlobalError] = useState();
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [sessionToken, setSessionToken] = useState();
    const telemetry = useTelemetry();
    const init = async () => {
        setLoading(true);
        const res = await corbadoApp.init();
        if (res.err) {
            setGlobalError(res.val);
            return;
        }
        setLoading(false);
    };
    useEffect(() => {
        void init();
        const userSub = corbadoApp.sessionService.userChanges.subscribe(value => {
            setUser(value);
        });
        const authStateSub = corbadoApp.sessionService.authStateChanges.subscribe(value => {
            setIsAuthenticated(!!value);
        });
        const sessionTokenSub = corbadoApp.sessionService.sessionTokenChanges.subscribe((value) => {
            setSessionToken(value);
        });
        return () => {
            userSub.unsubscribe();
            authStateSub.unsubscribe();
            sessionTokenSub.unsubscribe();
        };
    }, []);
    const getPasskeys = useCallback((abortController) => {
        telemetry.logMethodCalled('getPasskeys');
        return corbadoApp.sessionService.passkeyList(abortController !== null && abortController !== void 0 ? abortController : new AbortController());
    }, [corbadoApp, telemetry]);
    const appendPasskey = useCallback(() => {
        telemetry.logMethodCalled('appendPasskey');
        return corbadoApp.sessionService.appendPasskey();
    }, [corbadoApp, telemetry]);
    const logout = useCallback(() => {
        telemetry.logMethodCalled('logout');
        return corbadoApp.sessionService.logout();
    }, [corbadoApp, telemetry]);
    const deletePasskey = useCallback((id) => {
        telemetry.logMethodCalled('deletePasskey');
        return corbadoApp.sessionService.passkeyDelete(id);
    }, [corbadoApp, telemetry]);
    const getFullUser = useCallback((abortController) => {
        telemetry.logMethodCalled('getFullUser');
        return corbadoApp === null || corbadoApp === void 0 ? void 0 : corbadoApp.sessionService.getFullUser(abortController !== null && abortController !== void 0 ? abortController : new AbortController());
    }, [corbadoApp, telemetry]);
    return (React.createElement(CorbadoSessionContext.Provider, { value: {
            corbadoApp,
            sessionToken,
            loading,
            user,
            isAuthenticated,
            appendPasskey,
            getFullUser,
            getPasskeys,
            deletePasskey,
            logout,
            globalError,
        } }, children));
};
